module.exports = __webpack_public_path__ + "img/旋转木马母亲(1).abdac096.png";